import config from "../config.json";
import { ApiUrls } from "../utils/constants";
import { axiosPost } from "./axiosHelper";

// The top notifications are needed by both the header bell and the dashboard
// "New Notifications" widget. They are separate components that mount at the
// same time, so without sharing they each fire their own identical request.
// Keep a short-lived in-flight cache (keyed by profile + account) so concurrent
// callers reuse a single network call instead of duplicating it.
const TOP_NOTIFICATIONS_FETCH_COUNT = 100;
const TOP_NOTIFICATIONS_CACHE_TTL = 3000;

let cache = { key: null, promise: null, time: 0 };

export const fetchTopNotifications = ({
  profileId,
  accountId,
  force = false,
} = {}) => {
  const key = `${profileId}-${accountId}`;
  const now = Date.now();

  if (
    !force &&
    cache.key === key &&
    cache.promise &&
    now - cache.time < TOP_NOTIFICATIONS_CACHE_TTL
  ) {
    return cache.promise;
  }

  const promise = axiosPost(
    `${config.apiBaseUrl}${ApiUrls.getTopNotifications}`,
    {
      ProfileId: profileId,
      AccountId: accountId,
      IsRead: 0,
      Count: TOP_NOTIFICATIONS_FETCH_COUNT,
    }
  );

  // Don't keep a rejected request cached - allow the next mount to retry.
  promise.catch(() => {
    if (cache.promise === promise) {
      cache = { key: null, promise: null, time: 0 };
    }
  });

  cache = { key, promise, time: now };
  return promise;
};

export const invalidateTopNotifications = () => {
  cache = { key: null, promise: null, time: 0 };
};

// Take the first `limit` notifications across groups while preserving the
// grouped shape (mirrors the backend "Count" behaviour for the small widget).
export const takeTopNotifications = (data = [], limit) => {
  if (!Array.isArray(data)) return [];

  let remaining = limit;
  const result = [];

  for (const group of data) {
    if (remaining <= 0) break;
    const items = Array.isArray(group?.Notifications)
      ? group.Notifications
      : [];
    if (items.length === 0) continue;

    const take = items.slice(0, remaining);
    remaining -= take.length;
    result.push({ ...group, Notifications: take });
  }

  return result;
};
